import React, { useState } from 'react';

const Contact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    const formData = new FormData(e.target);
    
    try {
      const response = await fetch('https://formspree.io/f/xeqvjera', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setSubmitStatus('success');
        e.target.reset();
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section bg-background">
      <div className="container">
        <h2 className="section-title">Contact</h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Contact Information */}
          <div className="card p-8">
            <h3 className="font-montserrat text-2xl font-bold text-primary-500 mb-6">
              Get in Touch
            </h3>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-accent-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="fas fa-phone text-white text-lg"></i>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-montserrat font-semibold text-primary-500">Phone</p>
                  <a 
                    href="tel:+918080485895" 
                    className="text-text-muted hover:text-accent-500 transition-colors duration-300 break-all"
                  >
                    +91 8080485895
                  </a>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-accent-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="fas fa-envelope text-white text-lg"></i>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-montserrat font-semibold text-primary-500">Email</p>
                  <a 
                    href="mailto:contact@adeshpalyekar.com" 
                    className="text-text-muted hover:text-accent-500 transition-colors duration-300 break-all"
                  >
                    contact@adeshpalyekar.com
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          {/* Contact Form */}
          <div className="card p-8">
            <h3 className="font-montserrat text-2xl font-bold text-primary-500 mb-6">
              Send a Message
            </h3>
            
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="name" className="block font-montserrat font-semibold text-primary-500 mb-2">
                  Your Name
                </label>
                <input 
                  type="text" 
                  id="name" 
                  name="name"
                  required 
                  className="w-full px-4 py-3 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-transparent transition-all duration-300"
                  placeholder="Enter your name"
                />
              </div>
              
              <div>
                <label htmlFor="telephone" className="block font-montserrat font-semibold text-primary-500 mb-2">
                  Your Phone Number
                </label>
                <input 
                  type="tel" 
                  id="telephone" 
                  name="telephone"
                  required 
                  className="w-full px-4 py-3 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-transparent transition-all duration-300"
                  placeholder="Enter your phone number"
                />
              </div>
              
              <div>
                <label htmlFor="message" className="block font-montserrat font-semibold text-primary-500 mb-2">
                  Your Message
                </label>
                <textarea 
                  id="message" 
                  name="message"
                  rows="5" 
                  required 
                  className="w-full px-4 py-3 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-transparent transition-all duration-300 resize-none"
                  placeholder="Enter your message"
                ></textarea>
              </div>
              
              <button 
                type="submit" 
                className="btn-primary w-full"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </button>

              {/* Success Message */}
              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-4 mt-4">
                  <div className="flex items-center gap-2">
                    <i className="fas fa-check-circle text-green-500"></i>
                    <p className="text-green-700 font-medium">
                      Thank you! Your message has been sent successfully.
                    </p>
                  </div>
                </div>
              )}

              {/* Error Message */}
              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 mt-4">
                  <div className="flex items-center gap-2">
                    <i className="fas fa-exclamation-circle text-red-500"></i>
                    <p className="text-red-700 font-medium">
                      Sorry, there was an error sending your message. Please try again.
                    </p>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 